export default "__VITE_PUBLIC_ASSET__70f7e5e0__"